import { API_URL } from '@/const/env';
import { tokenStore } from '@/auth/token';
import { API_ROUTES } from './routes';
import { SimpleChartData } from '@/features/360-analysis/charts/SimpleChartEngine/types';

export interface ISendMessageResponse {
  response: string;
  sessionId: string;
  charts: SimpleChartData[];
  toolsExecuted: Array<{ tool: string; input: Record<string, unknown> }>;
}

export interface IHistoryMessage {
  role: 'user' | 'assistant' | 'tool';
  content: string;
  timestamp: string;
}

export interface IGetHistoryResponse {
  history: IHistoryMessage[];
  sessionId: string;
  totalMessages: number;
}

const authHeaders = () => {
  const token = tokenStore.get();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const aiChatApi = {
  sendMessage: async (
    companyId: string,
    message: string,
    sessionId: string | null,
  ): Promise<ISendMessageResponse> => {
    const url = `${API_URL}/company/${companyId}/ai/chat`;
    const res = await fetch(url, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ message, ...(sessionId ? { sessionId } : {}) }),
    });

    if (!res.ok) throw new Error(`AI chat error: ${res.status}`);
    return res.json() as Promise<ISendMessageResponse>;
  },

  getHistory: async (companyId: string): Promise<IGetHistoryResponse> => {
    const url = `${API_URL}${API_ROUTES.aiChat.history(companyId)}`;
    const res = await fetch(url, { headers: authHeaders() });
    if (!res.ok) throw new Error(`AI chat history error: ${res.status}`);
    return res.json() as Promise<IGetHistoryResponse>;
  },

  clearHistory: async (companyId: string, sessionId: string): Promise<void> => {
    const url = `${API_URL}${API_ROUTES.aiChat.clearHistory(companyId)}`;
    await fetch(url, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ sessionId }),
    });
  },
};
